<template>
  <div id="blockly">
    <div class="blocklyDiv" ref="blocklyDiv"></div>
  </div>
</template>

<script>
import { mapState, mapMutations } from 'vuex'
import Blockly from 'blockly'
import { DisableTopBlocks } from '@blockly/disable-top-blocks'
import blocklyToolbox from '@/blockly/toolbox/blocklyToolbox'
import blocklyToolboxDefault from '@/blockly/toolbox/blocklyToolboxDefault'
import blocklyToolboxIFLine from '@/blockly/toolbox/blocklyToolboxIFLine'
import {
  blocklyToolboxIFKit,
  ifkitAdd
} from '@/blockly/toolbox/blocklyToolboxIFKit'
import blocklyToolboxIFBalance from '@/blockly/toolbox/blocklyToolboxIFBalance'
import blocklyToolboxIFZero from '@/blockly/toolbox/blocklyToolboxIFZero'
import blocklyToolboxIFZeroLite from '@/blockly/toolbox/blocklyToolboxIFZeroLite'
// import blocklyToolboxOrigin from '@/blockly/blocklyToolboxOrigin'
import blocklyTheme from '@/blockly/blocklyTheme'
import blocklyUtil from '@/blockly/blocklyUtil'
import blocklyCustomCategory from '@/blockly/blocklyCustomCategory'
import '@/blockly/blocklyModify'
import blocks from '@/blockly/blocks'
import storage from '@/libs/storage'
// import blockType from '@/libs/blockType'

import * as En from 'blockly/msg/en'
import { blocklyEn } from '@/msg/en'

import * as Ko from 'blockly/msg/ko'
import { blocklyKo } from '@/msg/ko'

export default {
  name: 'BlockArea',
  data() {
    return {
      workspace: null,
      options: {
        media: 'media/',
        grid: {
          spacing: 25,
          length: 3,
          colour: '#eee',
          snap: true
        },
        zoom: {
          controls: true,
          wheel: true,
          startScale: 1.0,
          maxScale: 3,
          minScale: 0.3,
          scaleSpeed: 1.2,
          pinch: true
        },
        toolbox: blocklyToolbox,
        theme: blocklyTheme,
        comments: false
      },
      isMounted: false,
      disableArr: []
    }
  },
  computed: {
    ...mapState([
      'phoneMode',
      'language',
      'showSideBar',
      'showCode',
      'userInfo',
      'project',
      'blocklyXml',
      'device'
    ])
  },
  mounted() {
    log('BlockArea mounted()')
    this.setLanguage(this.language)
    blocklyCustomCategory.init(this.language)
    if (this.phoneMode) Blockly.Scrollbar.scrollbarThickness = 8
    // toolBox modify
    this.options.toolbox.contents = this.getToolbox()
    this.workspace = Blockly.inject(this.$refs['blocklyDiv'], this.options)

    let xml = storage.local.getItem('workspace')
    xml = _.replace(xml, /disabled="true"/g, '')
    blocklyUtil.setWorkspaceXml(xml)
    this.workspace.addChangeListener(this.setDisableHandler)
    this.workspace.addChangeListener(_.debounce(this.setCodeHandler, 500))
    this.workspace.addChangeListener(Blockly.Events.disableOrphans)
    const disableTopBlocksPlugin = new DisableTopBlocks()
    disableTopBlocksPlugin.init()
  },
  watch: {
    showSideBar() {
      this.resize(15)
    },
    showCode(newVal) {
      if (newVal) {
        Blockly.hideChaff()
      }
    },
    device() {
      log('BlockArea device()')
      this.options.toolbox.contents = this.getToolbox()
      this.workspace.updateToolbox(this.options.toolbox)
      let toolbox = this.workspace.getToolbox()
      if (toolbox && toolbox.getFlyout() && toolbox.getFlyout().autoClose) {
        toolbox.clearSelection()
      }

      // this.disableArr = blockType.getDisableBlocks(newVal)
      // let xml = storage.local.getItem('workspace')
      // xml = _.replace(xml, /disabled="true"/g, '')
      // blocklyUtil.setWorkspaceXml(xml)
      // blocklyUtil.setDisableByDevice(this.disableArr, true)
    }
  },
  methods: {
    ...mapMutations(['setCode', 'setBlocklyXml', 'setIsModified']),
    setDisableHandler() {
      blocklyUtil.setDisableByDevice(this.disableArr)
    },
    setCodeHandler() {
      log('BlockArea setCodeHandler()')
      const xml = blocklyUtil.getWorkspaceXml()
      if (this.isMounted) {
        storage.local.setItem('workspace', xml)
        const uid = _.get(this.userInfo, 'uid')
        const fileName = this.project.fileName
        const type = this.project.type
        const currentJson = { uid, fileName, type }
        storage.local.setItem('current', JSON.stringify(currentJson))
      }
      let isModified = false
      if (this.blocklyXml) {
        isModified = this.blocklyXml !== xml
        storage.local.setItem('isModified', isModified)
      } else {
        this.setBlocklyXml(
          '<xml xmlns="https://developers.google.com/blockly/xml"></xml>'
        )
        isModified = storage.local.getItem('isModified') === 'true'
      }
      this.setIsModified(isModified)
      this.isMounted = true
      blocklyUtil.oneBlockForType('start_on_boot')
      let code = Blockly.Python.workspaceToCode(this.workspace)
      this.setCode(code.replace(/\n\n\n/g, '\n\n'))
    },
    setLanguage(language) {
      if (language === 'ko') {
        Blockly.setLocale(Ko)
        Blockly.setLocale(blocklyKo)
      } else {
        Blockly.setLocale(En)
        Blockly.setLocale(blocklyEn)
      }
    },
    resize(count) {
      if (count > 0) {
        setTimeout(() => {
          Blockly.svgResize(this.workspace)
          this.resize(--count)
        }, 30)
      }
    },
    getToolboxWithAdd(deviceToolbox, defaultToolbox, add) {
      if (add) {
        const toolbox = _.concat(deviceToolbox, _.cloneDeep(defaultToolbox))
        _.forEach(add, (contentsArr, categorystyle) => {
          const catetory = _.find(toolbox, { categorystyle })
          const contents = _.get(catetory, 'contents')
          _.set(catetory, 'contents', _.concat(contents, contentsArr))
        })
        return toolbox
      } else {
        return _.concat(deviceToolbox, defaultToolbox)
      }
    },
    getToolbox() {
      log('BlockArea getToolbox()')
      log(this.device)
      // return blocklyToolboxOrigin
      const deviceType = _.get(this.device, 'type')
      switch (deviceType) {
        case 'ifline':
          blocks.setIflineLedImageUrl('https://i.ibb.co/BZBYHry/iF-Line.jpg')
          return this.getToolboxWithAdd(
            blocklyToolboxIFLine,
            blocklyToolboxDefault
          )
        case 'ifzeroKit': {
          return this.getToolboxWithAdd(
            blocklyToolboxIFKit,
            blocklyToolboxDefault,
            ifkitAdd
          )
        }
        case 'ifbalance':
          blocks.setIflineLedImageUrl(
            'https://i.ibb.co/tqJGMbM/i-F-Balance.jpg'
          )
          return this.getToolboxWithAdd(
            blocklyToolboxIFBalance,
            blocklyToolboxDefault
          )
        case 'ifzero':
          return this.getToolboxWithAdd(
            blocklyToolboxIFZero,
            blocklyToolboxDefault
          )
        case 'ifzeroLite':
          return this.getToolboxWithAdd(
            blocklyToolboxIFZeroLite,
            blocklyToolboxDefault
          )
        default:
          break
      }
      return blocklyToolboxDefault
    }
  }
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
.blocklyDiv {
  height: 100%;
  width: 100%;
  text-align: left;
}
</style>

<style>
#blockly {
  display: inline-block;
  width: 100%;
  /* height: calc(100% - 56px); */
  height: 100%;
}

/* toolbox */
.blocklyTreeLabel {
  margin-left: 10px;
  font-family: NanumSquare, Roboto, Helvetica Neue, Helvetica, Arial, sans-serif !important;
  font-weight: 600;
  font-size: 18px;
}
.blocklyToolboxContents {
  padding: 0;
}
.blocklyTreeRowContentContainer {
  display: flex;
  flex-direction: row;
  align-items: center;
  padding: 10px;
  font-weight: 600;
  font-size: 18px;
}
.blocklyTreeRow {
  height: initial;
  padding: 0;
  margin: 0;
  border-radius: 0;
  box-shadow: inset 0 -1px 0 0 #ecf0f1;
  cursor: pointer;
  height: 41px;
}
.blocklyToolboxCategory {
  background-color: black;
}
.blocklyTreeRow:hover {
  opacity: 0.9;
}
.blocklyToolboxDiv {
  min-width: 120px;
  background-color: white;
  padding: 0;
  border-right: solid 1px #ecf0f1;
}

.blocklyToolboxCategory .categoryIfblock {
  position: relative;
  top: -5px;
  left: -5px;
  width: 30px;
  height: 30px;
  background-size: cover;
}

.blocklyToolboxCategory .categoryIfblock.categoryIfline {
  background-image: url(https://i.ibb.co/BZBYHry/iF-Line.jpg);
}

.blocklyToolboxCategory .categoryIfblock.categoryIfkit {
  background-image: url(https://i.ibb.co/Njth70r/i-FZero-Kit.jpg);
}

.blocklyToolboxCategory .categoryIfblock.categoryIfbalance {
  background-image: url(https://i.ibb.co/tqJGMbM/i-F-Balance.jpg);
}

.blocklyToolboxCategory .categoryIfblock.categoryIfzero {
  background-image: url(https://i.ibb.co/VSkSG3B/i-F-Zero-Board.jpg);
}

.blocklyToolboxCategory .categoryIfblock.categoryIfzeroLite {
  background-image: url(https://i.ibb.co/7XC7YpL/i-FZero-Lite.jpg);
}

.blocklyToolboxCategory .categoryIfblock + .blocklyTreeLabel {
  position: relative;
  top: -5px;
  left: -12px;
}

/* block */
.blocklyFlyoutBackground {
  fill: #4b4949;
  fill-opacity: 1;
}

/* workspace */
.blocklyWidgetDiv .blocklyMenu {
  border-top: none;
  border-bottom: none;
}

/* checkbox */
.blocklyEditableText:not(.editing) > .blocklyFieldRect.ifblockChecked {
  fill: #000;
  fill-opacity: 0.4;
}

.blocklyEditableText .ifblockCheckBox + .blocklyText {
  display: none !important;
}

@media only screen and (max-width: 600px) {
  .blocklyToolboxDiv {
    min-width: 38px;
  }

  .blocklyToolboxDiv svg + span {
    display: none;
  }

  #blockly .blocklyFlyout {
    transform: translate(39px, 0px) !important;
  }

  .blocklyToolboxDiv svg + span {
    display: flex;
  }
}
</style>
